<template>
    <div>
        <h1 class="has-no-margin-bottom">{{$t('referrals.header_main')}}</h1>

        <referral-form v-model="email" @submit="submitReferral" :disabled="!canSumbit" :busy="submit.loading"/>

        <div class="hr--dotted"></div>

        <div class="block--mobile">
            <h2>{{$t('referrals.header_table')}}</h2>
            <p>{{$t('referrals.label_table_info')}}</p>
            <loader v-bind="fetch" class="table__responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>{{$t('referrals.header_email')}}</th>
                        <th>{{$t('referrals.header_date')}}</th>
                        <th>{{$t('referrals.header_state')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="referral in referrals">
                        <td>{{referral.email}}</td>
                        <td>{{formatDate(referral.date)}}</td>
                        <td >
                            <i :class="stateIconClass(referral.state)"></i>
                            {{$t('referrals.state_detail.' + stateTranslationLabel(referral.state))}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </loader>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import ReferralForm from '../components/forms/ReferralForm';
    import {
        FETCH_REFERRALS,
        GET_REFERRALS,
        REFERRAL_PENDING,
        REFERRAL_ACCEPTED,
        REFERRAL_DISCOUNT_RECEIVED,
        SUBMIT_REFERRAL
    } from '../store/modules/referrals';
    import moment from 'moment';
    import Loader from '../components/general/Loader';

    @Component({
        components: {Loader, ReferralForm}
    })
    export default class Referrals extends Vue {
        email = null;
        fetch = {loading: false};
        submit = {loading: false};

        created() {
            this.fetch.loading = true;
            this.fetchReferrals();
        }

        async fetchReferrals(){
            try {
                this.fetch.loading = true;
                await this.$store.dispatch(FETCH_REFERRALS);
            } catch (e){
                this.$notify.error(this.$t('common.notify_fetch_failure'));
            } finally {
                this.fetch.loading = false;
            }
        }

        async submitReferral(){
            this.submit.loading = true;
            try {
                await this.$store.dispatch(SUBMIT_REFERRAL, this.email);
            } catch (e){
                this.$notify.error(this.$t('form.referral.notify_failure'));
            } finally {
                this.submit.loading = false;
                this.email = '';
            }
        }

        get referrals() {
            return this.$store.getters[GET_REFERRALS];
        }

        get canSumbit(){
            return this.email && this.email.length && this.email.includes('@');
        }

        formatDate(date) {
            //format default date string
            if (typeof date === 'string'){
                const dateTimeArray = date.split(' ');
                const timeArray = dateTimeArray[1].split(':');
                const dateArray = dateTimeArray[0].split('-');
                return moment(new Date(dateArray[2], dateArray[1] - 1, dateArray[0], timeArray[0], timeArray[1])).lang(this.$i18n.locale).format('LLLL');
            } else if (typeof date === 'number') {
                var d = new Date(0);
                d.setUTCSeconds(date);
                return moment(d).lang(this.$i18n.locale).format('LLLL');
            }
        }

        stateIconClass(state) {
            switch (state) {
            case REFERRAL_PENDING:
                return 'mdi mdi-email';
            case REFERRAL_ACCEPTED:
                return 'mdi mdi-currency-eur';
            case REFERRAL_DISCOUNT_RECEIVED:
                return 'mdi mdi-check';
            }
        }

        stateTranslationLabel(state){
            switch (state){
            case REFERRAL_PENDING:
                return 'in_progress';
            case REFERRAL_ACCEPTED:
                return 'completed';
            case REFERRAL_DISCOUNT_RECEIVED:
                return 'used';
            }
        }
}
</script>



// WEBPACK FOOTER //
// src/pages/Referrals.vue